<template>
  <div id="demo-basic-card">

    <div id="addModuleLoadingDiv" class="vs-con-loading__container">
        <vx-card :title="category_data.name_en" class="mb-base">
            <template   slot="actions">
                <vx-tooltip text="Back to all categories" position="left">
                    <feather-icon @click="redirectToAllCategories()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input v-validate="'required'" name="name_en" ref="name_en" class="w-full" label="Category name (English)" v-model="category_data.name_en" />
                    <span class="text-danger text-sm" v-show="errors.has('name_en')">{{ errors.first('name_en') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input v-validate="'required'" name="name_da" ref="name_da" class="w-full" label="Category name (Danish)" v-model="category_data.name_da" />
                    <span class="text-danger text-sm" v-show="errors.has('name_da')">{{ errors.first('name_da') }}</span>
                </div>
            </div>
            
            <div class="vx-row">
                <div class="vx-col w-full"  align="right">
                  <vs-button @click="validateCategoryForm()" class="mr-3 mb-2">Update Category</vs-button>
                </div>
            </div>
        </vx-card>
    </div>

  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleLearningHub from '@/store/learninghub/moduleLearningHub.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            category_data: {
                name_en: '',
                name_da: ''
            },
            module_not_found: false,
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
    },
    methods: {
        redirectToAllCategories() {
            this.$router.push("/learninghubcategories").catch(() => {})
        },
        validateCategoryForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateCategory()
            })
        },
        updateCategory() {
            this.$vs.loading({
                container: '#addModuleLoadingDiv',
                scale: 0.6
            })

            let categoryData = this.category_data
            categoryData.id = this.$route.params.id
            this.$store.dispatch("learninghubManagement/updateCategory", categoryData)
            .then(res => { 
                this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                    time:4000,
                    title:'Success',
                    text: (res.data.status) ? res.data.status : 'Category Updated successfully.',
                    color:'success',
                    iconPack: 'feather',
                    icon:'icon-alert-circle'
                });

                this.$router.push("/learninghubcategories/edit/" + res.data.data.id).catch(() => {})
            })
            .catch(err => {
                this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')
            })
        },
    },
    created() {

        if(!moduleLearningHub.isRegistered) {
            console.log('is registered not');
            this.$store.registerModule('learninghubManagement', moduleLearningHub)
            moduleLearningHub.isRegistered = true
        }

        
        const id = this.$route.params.id
        
        this.$store.dispatch("learninghubManagement/getACategory", id)
            .then(res => { 

                this.category_data = res.data 
                
            })
            .catch(err => {

                console.log( err );
                
            })
            
    },

}
</script>

